<template>
  <div>
    <div class="container noprint">
      <AdminHeader></AdminHeader>
      <div class="search_info">
        <div class="keyword_time">
          <span>查詢</span>
        <div class="keyword">
          <label for="keyword">關鍵字：</label>
          <input v-on:keyup.enter="searchOrder" :value="$store.getters.getCurrentOrderKeyword" @input="$store.dispatch('updateCurrentOrderKeyword',$event.target.value)" class="input_keyword" placeholder="訂單編號、收件人、電話、地址" type="text">
        </div>
        <div class="date">
          <label for="time">時間：</label>
            <datepicker :clear-button="true" :calendarButton="true" :calendar-button-icon="icon" class="input_date" placeholder="選擇日期" :value="$store.getters.getCurrentOrderDateFrom" @input="$store.dispatch('updateCurrentOrderDateFrom',$event)"></datepicker>
            至
            <datepicker :clear-button="true" :calendarButton="true" :calendar-button-icon="icon" class="input_date" placeholder="選擇日期" :value="$store.getters.getCurrentOrderDateTo" @input="$store.dispatch('updateCurrentOrderDateTo',$event)"></datepicker>
          <button class="search btn" v-on:click="searchOrder">搜尋</button>
        </div>
        </div>
        <div class="order_status">
          <div class="order orderStatus" :class="$store.getters.getCurrentOrderStatus === '0'?'active':''" v-on:click="refreshOrder('0',$event)">未付訂單</div>
          <div class="order orderStatus" :class="$store.getters.getCurrentOrderStatus === '1'?'active':''" v-on:click="refreshOrder('1',$event)">未出貨訂單</div>
          <div class="order orderStatus" :class="$store.getters.getCurrentOrderStatus === '2'?'active':''" v-on:click="refreshOrder('2',$event)">已完成訂單</div>
          <div class="order orderStatus guild" :class="$store.getters.getCurrentOrderStatus === '3'?'active':''" v-on:click="refreshOrder('3',$event)">特約未付款</div>
          <div class="order orderStatus guild" :class="$store.getters.getCurrentOrderStatus === '4'?'active':''" v-on:click="refreshOrder('4',$event)">特約未出貨</div>
          <div class="order orderStatus guild" :class="$store.getters.getCurrentOrderStatus === '5'?'active':''" v-on:click="refreshOrder('5',$event)">特約已完成</div>
          <div class="number_of_order order">{{pagination.from}}-{{pagination.to}}筆（共{{pagination.total}}筆)
            <span class="previous" v-on:click="changePage('previous')">&#8249;</span>
            <span class="nextPage" v-on:click="changePage('next')">&#8250;</span>
          </div>
        </div>
      </div>
      <div class="print_delete" v-if="anyOrderBechecked">
        <button class="minus" v-on:click="cancelAllChecks">&#8722;</button>
        <button class="print_bigpic btn" v-on:click="goToImagePrint">大圖列印</button>
        <button class="print_postCo_mailing btn" @click="getPrintMailData">郵寄資訊列印</button>
        <button class="print_report btn" @click="getReportData" v-if="$store.getters.getAdminLevel === 255">報表列印</button>
        <button class="export_report btn" @click="exportReport" v-if="$store.getters.getAdminLevel === 255">報表匯出</button>
        <button class="delete_order btn" v-on:click="deleteOrders('becheckedOrders')">刪除訂單</button>
      </div>
  		<div class="container-table">
        <table>
          <thead>
            <tr class="order_title" v-if="!anyOrderBechecked">
              <th><input type="checkbox" v-on:change="allOrderCheck($event)"></th>
              <th class="title_number">訂單編號</th>
              <th class="title_person">收件人</th>
              <th class="title_phone">聯絡電話</th>
              <th class="title_address">寄送地址</th>
              <th class="title_time">下單時間</th>
              <th class="title_money">訂單金額</th>
              <th class="title_status">訂單狀態</th>
              <th class="title_delete">刪除</th>
            </tr>
          </thead>
          <div class="load" v-if="!orders">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div class="" v-else-if="isNoAnyOrder">
            無任何訂單
          </div>
          <tbody v-else>
            <tr class="order_info order_no_pay singleOrder" v-for="(item,index) in orders" :key="item.id">
              <td><input class="singleOrderInput" type="checkbox" v-on:change="orderCheck(item.id,$event)"></td>
              <td class="number" data-th="訂單編號">
                <router-link :to="{ name: 'admin_orderDetail', params: {id:item.id} }">{{item.trade_no}}</router-link>
              </td>
              <td class="person" data-th="收件人">{{item.full_name}}</td>
              <td class="phone" data-th="聯絡電話">{{item.phone}}</td>
              <td class="address" data-th="寄送地址">{{item.postal_code}}{{item.address}}</td>
              <td class="time" data-th="下單時間">{{item.created_at}}</td>
              <td class="money" data-th="訂單金額">{{item.sum}}</td>
              <td class="status" data-th="訂單狀態" v-if="item.is_shipped == 1">已完成</td>
              <td class="status unshipping_status" data-th="訂單狀態" v-else-if="item.is_paid == 1">
                <span>未出貨</span>
                <span v-if="item.is_notify===1"><img src="@/images/email-confirm-ok.png" alt=""></span>
                <span v-else-if="item.is_check===1"><img src="@/images/email-confirm.png" alt=""></span>
                <div class="post_number" v-if="item.postal_trace_code !== null">
                  郵局單號:{{ item.postal_trace_code  }}
                </div>
              </td>
              <td class="status done_status" data-th="訂單狀態" v-else>
                <span>未付款</span>
                <span class="btn-payment-notification" v-if="$store.getters.getCurrentOrderStatus==='3'||$store.getters.getCurrentOrderStatus==='0'">
                  <button @click="payInfolightboxControl(index)" :class="{'disabled-status':item.report.length ===0}">付款回報</button>
                </span>
              </td>
              <td class="delete" v-on:click="deleteOrders(item.id)" data-th="刪除">&#10005;</td>
            </tr>
          </tbody>
        </table>
  		</div>
    </div>
    <section>
      <div class="lightbox" v-if="!closeLightbox">
        <div class="lightbox-target">
          <p class="title">編號{{orders[`${payInfoIndex}`].trade_no}}的回報</p>
          <div class="mail-content-container">
            <div class="content-container">
              <div class="content-item" v-if="orders[`${payInfoIndex}`].report[0]">
                <p>付款日期 : {{orders[`${payInfoIndex}`].report[0].updated_at}}</p>
                <p>付款銀行 : {{orders[`${payInfoIndex}`].report[0].payment_bank_name}}</p>
                <p>付款金額 : {{orders[`${payInfoIndex}`].report[0].payment_amount}}</p>
                <p>帳號後五碼 : {{orders[`${payInfoIndex}`].report[0].payment_account_last_five}}</p>
              </div>
              <div class="content-item" v-else>
                <p>目前尚無任何回報資訊</p>
              </div>
            </div>
            <div class="sent-btn-container">
              <button class="sent-btn" @click="checkHaveCheckout">確認付款</button>
            </div>
          </div>
          <div class="lightbox-close" @click="closeLightbox=!closeLightbox">
            <img src="@/images/admin-lightbox-cross.png" alt="close">
          </div>
        </div>
      </div>
    </section>
    <AdminPrint id="print" v-if="printWho==='image'"></AdminPrint>
    <AdminPrintReport id="print" v-if="printWho==='report'" :printReportData="reportData" :printReportSum="reportSum"></AdminPrintReport>
    <AdminPrintPostCoMailingInfo id="print" v-if="printWho==='mailInfo'" :printMailData="printMailData"></AdminPrintPostCoMailingInfo>
    <div class="printPrepare" v-if="printPrepare">列印準備中...<i class="fa fa-print"></i></div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import AdminHeader from "@/components/admin/admin_header.vue";
import AdminPrint from "@/views/admin/admin_print.vue";
import Datepicker from "vuejs-datepicker";
import "../../scss/_datepicker_plugin.scss";
import AdminPrintReport from "@/views/admin/admin_printReport.vue";
import AdminPrintPostCoMailingInfo from "@/views/admin/admin_printPostCoMailingInfo.vue";
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  name: "adminOrderList",
  components: {
    AdminHeader,
    AdminPrint,
    Datepicker,
    AdminPrintReport,
    AdminPrintPostCoMailingInfo
  },
  created() {
    this.getOrders();
  },
  data() {
    return {
      icon: "fa fa-calendar",
      orders: "",
      pagination: "",
      becheckedOrders: [],
      anyOrderBechecked: false,
      printPrepare: false,
      isNoAnyOrder: true,
      closeLightbox: true,
      payInfoIndex: 0,
      //image、report、mailInfo、guarantee
      printWho: "",
      reportData: [],
      reportSum: {
        countSum: 0,
        weightSum: 0,
        goldpriceSum: 0,
        goldcostSum: 0,
        goldprofitSum: 0,
        feepriceSum: 0,
        feecostSum: 0,
        feeprofitSum: 0,
        postalcostSum: 0
      },
      printGuaranteeData: [],
      printMailData: []
    };
  },
  watch: {
    pagination: {
      handler() {
        let previous = document.querySelector(".previous");
        let nextPage = document.querySelector(".nextPage");
        previous.style.color = "#4a4a4a";
        previous.style.pointerEvents = "auto";
        nextPage.style.color = "#4a4a4a";
        nextPage.style.pointerEvents = "auto";
        if (this.$store.getters.getCurrentOrderPage == "1") {
          previous.style.color = "#9b9b9b";
          previous.style.pointerEvents = "none";
        }
        if (
          this.$store.getters.getCurrentOrderPage == this.pagination.lastPage
        ) {
          nextPage.style.color = "#9b9b9b";
          nextPage.style.pointerEvents = "none";
        }
      },
      deep: true
    },
    becheckedOrders() {
      if (this.becheckedOrders.length == 0) {
        this.anyOrderBechecked = false;
      } else {
        this.anyOrderBechecked = true;
      }
    },
    printLoading() {
      if (this.printLoading) {
        //定時器
        setTimeout(this.print, 1000);
        this.printPrepare = false;
      }
    }
  },
  methods: {
    getOrders() {
      let apiUrl =
        this.$store.getters.getGlobalUrl +
        `admin/orders?status=${
          this.$store.getters.getCurrentOrderStatus
        }&page=${this.$store.getters.getCurrentOrderPage}`;
      if (this.$store.getters.getCurrentOrderDateFrom !== "") {
        apiUrl =
          apiUrl +
          `&start=${this.$store.getters.getCurrentOrderDateFrom}&end=${
            this.$store.getters.getCurrentOrderDateTo
          }`;
      }
      if (this.$store.getters.getCurrentOrderKeyword !== "") {
        apiUrl =
          apiUrl + `&keyword=${this.$store.getters.getCurrentOrderKeyword}`;
      }
      axios({
        url: apiUrl,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.$store.getters.getBackstageToken}`
        }
      })
        .then(response => {
          if (response.data.data.items.length == 0) {
            this.isNoAnyOrder = true;
          } else {
            this.isNoAnyOrder = false;
          }
          this.orders = response.data.data.items;
          this.pagination = response.data.data.pagination;
          this.$nextTick(function() {
            this.examineBeChecked();
          });
        })
        .catch(e => {
          if (e.response.status === 401) {
            Cookies.remove("goldAdminUser");
            this.$store.dispatch("setBackstageToken", "");
            this.$store.dispatch("setAdminLevel", "");
            alert(`帳號權限已過期，請重新登入`);
            this.$router.push({ name: "admin_login" });
          } else {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          }
        });
    },
    deleteOrders(orderId) {
      let userResponse = confirm("您確定刪掉此筆訂單嗎?");
      if (userResponse) {
        let deleteOrdersId = "";
        if (orderId == "becheckedOrders") {
          deleteOrdersId = this.becheckedOrders.join(",");
        } else {
          deleteOrdersId = orderId;
        }
        axios({
          url:
            this.$store.getters.getGlobalUrl + `admin/orders/${deleteOrdersId}`,
          method: "delete",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        })
          .then(() => {
            alert("此筆訂單已刪除");
            this.orderReset();
            this.getOrders();
            this.$store.dispatch("updateCurrentOrderPage", "1");
            this.$store.dispatch("updateCurrentOrderKeyword", "");
            this.$store.dispatch("updateCurrentOrderDate", {
              from: "",
              to: ""
            });
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      }
    },
    orderCheck(id, e) {
      if (e.srcElement.checked == true) {
        this.becheckedOrders.push(id);
        e.target.parentElement.parentElement.classList.add("beChecked");
      } else {
        this.becheckedOrders.forEach((item, index) => {
          if (item == id) {
            this.becheckedOrders.splice(index, 1);
            e.target.parentElement.parentElement.classList.remove("beChecked");
          }
        });
      }
    },
    allOrderCheck(e) {
      let allOrderInput = document.querySelectorAll(".singleOrderInput");
      if (e.srcElement.checked == true) {
        allOrderInput.forEach(item => {
          item.checked = true;
          item.parentElement.parentElement.classList.add("beChecked");
        });
        this.becheckedOrders = [];
        this.orders.forEach(item => {
          this.becheckedOrders.push(item.id);
        });
      } else {
        allOrderInput.forEach(item => {
          item.checked = false;
          item.parentElement.parentElement.classList.remove("beChecked");
        });
        this.becheckedOrders = [];
      }
    },
    cancelAllChecks() {
      this.becheckedOrders = [];
      let allOrderInput = document.querySelectorAll(".singleOrderInput");
      allOrderInput.forEach(item => {
        item.checked = false;
        item.parentElement.parentElement.classList.remove("beChecked");
      });
    },
    refreshOrder(status) {
      this.orderReset();
      this.$store.dispatch("updateCurrentOrderStatus", status);
      this.getOrders();
    },
    searchOrder() {
      let dateFrom = this.$store.getters.getCurrentOrderDateFrom;
      let dateTo = this.$store.getters.getCurrentOrderDateTo;
      let transformDataFrom = "";
      let transformDataTo = "";
      if (![null, ""].includes(dateFrom) && ![null, ""].includes(dateTo)) {
        if (dateFrom > dateTo) {
          let dataFromSave = dateFrom;
          dateFrom = dateTo;
          dateTo = dataFromSave;
        }
      }
      if (![null, ""].includes(dateFrom) && [null, ""].includes(dateTo)) {
        dateTo = dateFrom;
      }
      if (![null, ""].includes(dateTo) && [null, ""].includes(dateFrom)) {
        dateFrom = dateTo;
      }
      if (![null, ""].includes(dateFrom) && ![null, ""].includes(dateTo)) {
        transformDataFrom = this.moment(dateFrom).format("YYYY-MM-DD");
        transformDataTo = this.moment(dateTo).format("YYYY-MM-DD");
      }
      this.$store.dispatch("updateCurrentOrderDate", {
        from: transformDataFrom,
        to: transformDataTo
      });
      this.getOrders();
      this.orderReset();
    },
    changePage(pageAction) {
      let lastPage = this.pagination.lastPage;
      let cuerrntPage = this.$store.getters.getCurrentOrderPage;
      if (pageAction == "previous") {
        cuerrntPage = cuerrntPage - 1;
        if (cuerrntPage < 1) {
          return;
        }
      }
      if (pageAction == "next") {
        cuerrntPage = parseInt(cuerrntPage) + 1;
        if (cuerrntPage > lastPage) {
          return;
        }
      }
      this.orders = "";
      this.pagination = "";
      this.$store.dispatch("updateCurrentOrderPage", cuerrntPage);
      this.getOrders();
    },
    examineBeChecked() {
      //確保換頁回來後，被選到的訂單，check box 爲 true
      let allOrderCheckbox = document.querySelectorAll(".singleOrderInput");
      if (this.becheckedOrders.length !== 0) {
        this.orders.forEach((order, orderIndex) => {
          this.becheckedOrders.forEach(beCheckedOrder => {
            if (order.id == beCheckedOrder) {
              allOrderCheckbox[`${orderIndex}`].checked = true;
              allOrderCheckbox[
                `${orderIndex}`
              ].parentElement.parentElement.classList.add("beChecked");
            }
          });
        });
      }
    },
    orderReset() {
      this.orders = "";
      this.pagination = "";
      this.becheckedOrders = [];
      this.anyOrderBechecked = false;
    },
    print() {
      window.print();
    },
    goToImagePrint() {
      this.printWho = "image";
      let printInfo = {
        id: [this.becheckedOrders],
        productIndex: "all"
      };
      this.$store.dispatch("setPrintInfo", printInfo);
      this.$store.dispatch("setPrintLoading", false);
      // this.printWho = 'image'
      this.printPrepare = true;
    },
    goToOtherPrint(who) {
      this.$store.dispatch("setPrintLoading", false);
      this.printWho = who;
      this.printPrepare = true;
    },
    async getReportData() {
      this.$store.dispatch("setPrintLoading", false);
      this.printWho = "report";
      this.printPrepare = true;
      try {
        let res = await this.$store.dispatch("getReportData", {
          id: this.becheckedOrders
        });
        this.reportData = res.data;
        this.calculateReportTotal();
        this.$store.dispatch("setPrintLoading", true);
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    async exportReport() {
      try {
        let res = await this.$store.dispatch("getReportData", {
          id: this.becheckedOrders
        });
        this.reportData = res.data;
        this.calculateReportTotal();
        this.downloadXlsx();
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    async downloadXlsx() {
      const wopts = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
        showGridLines: true
      };
      const wb = { SheetNames: ["Sheet1"], Sheets: {}, Props: {} };
      let data = this.downloadSheetData(this.reportData);
      wb.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(data);
      let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {
        type: "application/octet-stream"
      });
      FileSaver.saveAs(tmpDown, "報表.xlsx");
    },
    downloadSheetData(data) {
      let downloadSheetData = data.map(item => {
        return {
          產品編號: item.trade_no,
          下單日期: item.created_at,
          收件人: item.full_name,
          金牌數量: item.amount,
          "金牌總重量(錢)": item.weight,
          黃金收入: item.gold_price,
          黃金成本: item.gold_cost,
          黃金利潤: item.gold_profit,
          工錢收入: item.fee_price,
          工錢成本: item.fee_cost,
          工錢利潤: item.fee_profit,
          郵資: item.postal_cost
        };
      });
      downloadSheetData.push({
        產品編號: "",
        下單日期: "",
        收件人: "總和",
        金牌數量: this.reportSum.countSum,
        "金牌總重量(錢)": this.reportSum.weightSum,
        黃金收入: this.reportSum.goldpriceSum,
        黃金成本: this.reportSum.goldcostSum,
        黃金利潤: this.reportSum.goldprofitSum,
        工錢收入: this.reportSum.feepriceSum,
        工錢成本: this.reportSum.feecostSum,
        工錢利潤: this.reportSum.feeprofitSum,
        郵資: this.reportSum.postalcostSum
      });
      return downloadSheetData;
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        const buf = new Array(s.length);
        for (let i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    calculateReportTotal() {
      this.resetReportSum();
      this.reportData.forEach(data => {
        this.reportSum.countSum = this.reportSum.countSum + data.amount;
        this.reportSum.weightSum =
          parseFloat(this.reportSum.weightSum) + data.weight;
        this.reportSum.goldpriceSum =
          this.reportSum.goldpriceSum + data.gold_price;
        this.reportSum.goldcostSum =
          this.reportSum.goldcostSum + data.gold_cost;
        this.reportSum.goldprofitSum =
          this.reportSum.goldprofitSum + data.gold_profit;
        this.reportSum.feepriceSum =
          this.reportSum.feepriceSum + data.fee_price;
        this.reportSum.feecostSum = this.reportSum.feecostSum + data.fee_cost;
        this.reportSum.feeprofitSum =
          this.reportSum.feeprofitSum + data.fee_profit;
        this.reportSum.postalcostSum =
          this.reportSum.postalcostSum + data.postal_cost;
      });
      this.reportSum.weightSum = this.reportSum.weightSum.toFixed(2);
    },
    resetReportSum() {
      this.reportSum = {
        countSum: 0,
        weightSum: 0,
        goldpriceSum: 0,
        goldcostSum: 0,
        goldprofitSum: 0,
        feepriceSum: 0,
        feecostSum: 0,
        feeprofitSum: 0,
        postalcostSum: 0
      };
    },
    async getPrintMailData() {
      this.$store.dispatch("setPrintLoading", false);
      this.printWho = "mailInfo";
      this.printPrepare = true;
      try {
        let res = await this.$store.dispatch("getPrintMailData", {
          id: this.becheckedOrders
        });
        this.printMailData = this.arrangePrintMailData(res.data);
        this.$store.dispatch("setPrintLoading", true);
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    arrangePrintMailData(data) {
      //為了要用table排版列印，調整一下格式
      const newArr = [];
      let twoPostCoArray = [];
      for (let i = 0; i < data.length; i = i + 2) {
        if (data[i + 1]) {
          twoPostCoArray = [data[i], data[i + 1]];
        } else {
          twoPostCoArray = [data[i], {}];
        }
        newArr.push(twoPostCoArray);
      }
      return newArr;
    },
    payInfolightboxControl(index) {
      this.closeLightbox = false;
      this.payInfoIndex = index;
    },
    async checkHaveCheckout() {
      let useResponse = confirm("確認付款資訊無誤嗎？");
      if (!useResponse) {
        return;
      }
      try {
        await this.$store.dispatch(
          "checkHaveCheckout",
          this.orders[`${this.payInfoIndex}`].id
        );
        alert("更新成功");
        this.closeLightbox = true;
        this.getOrders();
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    }
  },
  computed: {
    printLoading() {
      return this.$store.getters.getPrintLoading;
    }
  }
};
</script>

<style scoped lang="scss">
body {
  color: $secondaryDeepColor1;
  font-size: 17px;
}
table {
  width: 100%;
}
table {
  border-collapse: collapse;
  border-top: 1px solid #ddd;
  .disabled-status {
    opacity: 0.5;
  }
}

.order_status,
tr,
td {
  border-bottom: 1px solid #ddd;
  .previous,
  .nextPage {
    color: #333;
    font-size: 24px;
    padding: 0 10px;
  }
}
.btn {
  width: 120px;
  height: 35px;
  border: 0;
  cursor: pointer;
  font-size: 17px;
  padding: 0;
}
.search_info {
  background-color: #f7f7f8;
  border-bottom: 1px #ddd solid;
  border: #f7f7f8;
  .keyword_time {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-top: 1px #ddd solid;
    .input_keyword {
      height: 32px;
      width: 345px;
      font-size: 17px;
      border: 1px #ddd solid;
      padding: 5px;
    }
    .date {
      display: flex;
      align-items: center;
      padding-left: 30px;
    }
  }
  span {
    padding: 0 30px;
    font-weight: bold;
  }
  .btn {
    background-color: #4a90e2;
    color: #fff;
    &:hover {
      background-color: darken(#4a90e2, 10%);
    }
  }
}
.print_delete {
  padding: 20px 30px;
  .btn {
    margin: 0 15px;
  }
  .print_bigpic,
  .print_insurance,
  .print_postCo_mailing,
  .print_report,
  .export_report {
    color: #4a90e2;
    border: 1px #4a90e2 solid;
    &:hover {
      color: darken(#4a90e2, 20%);
      border: 1px darken(#4a90e2, 20%) solid;
    }
  }
  .delete_order {
    color: #fd4c5e;
    border: 1px #fd4c5e solid;
    &:hover {
      color: darken(#fd4c5e, 20%);
      border: 1px darken(#fd4c5e, 20%) solid;
    }
  }
  .minus {
    background-color: #eee;
    border: 0;
    font-size: 17px;
  }
}

.order_status {
  display: flex;
  padding: 10px 0 0 0;
  color: #9b9b9b;
  .order {
    display: inline;
    cursor: pointer;
    padding: 10px 30px;
  }
  a {
    color: #4a4a4a;
    font-size: 24px;
    margin: 0 20px;
  }
  .number_of_order {
    margin-left: auto;
  }
  .active {
    color: #4a4a4a;
    border-bottom: 3px #4a4a4a solid;
  }
  .guild {
    color: #ffaf89;
  }
  .guild.active {
    color: #ff6c26;
    border-bottom: 3px #ff6c26 solid;
  }
}

.order_info {
  input {
    margin-left: 30px;
  }
  .number {
    cursor: pointer;
    a {
      color: black;
    }
    &:hover {
      color: #a8894c;
      text-decoration: underline;
    }
  }
}
tbody tr {
  &:hover {
    background-color: #f7f7f8;
  }
}
.beChecked {
  background-color: #f7f7f8;
}
.order_title,
.order_info {
  th {
    text-align: left;
    input {
      margin-left: 30px;
    }
  }
  input {
    height: 70px;
  }
  .delete {
    color: red;
    cursor: pointer;
    &:hover {
      color: darken(red, 10%);
    }
  }
}
.post_number {
  color: #9b9b9b;
}
.unshipping_status {
  color: #fd4c5e;
}
.done_status {
  color: #2ebb86;
  .btn-payment-notification {
    display: inline-block;
    margin-left: 15px;
    button {
      width: 90px;
      height: 36px;
      border-radius: 2px;
      color: $secondaryDeepColor1;
      border: solid 1px $secondaryLightColor1;
      background-color: #fff;
      font-size: 16px;
    }
    button:disabled {
      color: #979797;
      border: solid 1px #979797;
      opacity: 0.5;
    }
  }
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
//列印設定
#print {
  display: none;
}
@page {
  size: A4 portrait;
  margin: 0;
  // margin-top: 2cm;
  // margin-bottom: 2cm;
  // margin-left: 2cm;
  // margin-right: 2cm;
}

@media print {
  body {
    -webkit-print-color-adjust: exact !important;
  }
  .noprint {
    display: none;
  }
  #print {
    display: block;
  }
}
.printPrepare {
  position: absolute;
  width: 300px;
  height: 35px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  font-size: 24px;
  text-align: center;
  padding: 50px;
  color: $primaryDeepColor;
  border: 1px $primaryDeepColor solid;
  background-color: $secondaryColor3;
}

.lightbox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  z-index: 1111111;
  .lightbox-target {
    position: absolute;
    left: 0;
    right: 0;
    width: 600px;
    height: 90%;
    overflow: scroll;
    margin: 50px auto;
    background: $secondaryColor3;
    .title {
      margin-top: 0;
      padding: 23px 30px;
      font-weight: 600;
      border-bottom: 1px solid $secondaryLightColor1;
    }
  }
  .lightbox-close {
    position: absolute;
    top: 24px;
    right: 30px;
    cursor: pointer;
  }
  .mail-content-container {
    margin: 0 30px;
    .sent-btn-container {
      text-align: center;
      margin: 25px 0;
    }
    button {
      line-height: 35px;
      padding: 0 15px;
      border-radius: 2px;
      margin: auto;
      letter-spacing: 1px;
      font-size: 17px;
    }
    .sent-btn {
      color: $secondaryColor3;
      background-color: #4a90e2;
      &:hover {
        background-color: darken(#4a90e2, 10%);
      }
    }
  }
  .content-container {
    padding: 0 15px;
    border: 1px solid $secondaryLightColor1;
    border-radius: 2px;
    .content-item {
      padding: 20px 0;
      border-bottom: 1px solid $secondaryLightColor1;
      &:last-of-type {
        border-bottom: 0;
      }
    }
  }
}
.displaynone {
  display: none;
}
</style>
